<div class="confirm-dialog-wrapper">
    <div class="dialog-title">Warning</div>
    <div mat-dialog-content>
        <div style="padding: 13px 0;">{{message}}</div>
    </div>

    <mat-dialog-actions align="end">
        <div class="button-row">
            <button mat-raised-button color="primary" class="discard-btn" (click)="result()">Close</button>
        </div>
    </mat-dialog-actions>
</div>
